import { createContext } from 'react';

/** 편집기가 목록에 알리는 보존 대상: 저장하지 않은 입력, 결과를 확인하지 못한 요청. 둘 다 없으면 null. */
export interface PurposeDraftState {
  input: boolean;
  request: boolean;
}

/**
 * 장비 용도 편집기가 "저장하지 않은 입력이나 결과 미확정 요청이 있다"는 사실을 목록 쪽에 알리는 통로.
 * 목록(쪽 이동으로 행이 사라질 수 있는 곳)만 이 값을 제공하고, 없으면 편집기는 아무것도 알리지 않는다.
 * 키는 편집기마다 다른 값이다 — 같은 장비가 두 행에 있어도 한쪽이 닫혀서 다른 쪽의 초안 표시가 지워지지 않게.
 * 입력과 요청을 나눠 알리는 이유: 입력은 이동하면 사라지지만 요청은 같은 세션에서 돌아오면 이어서 확인할 수 있어 안내가 달라야 한다.
 */
export const PurposeDraftContext = createContext<
  ((editorKey: string, state: PurposeDraftState | null) => void) | null
>(null);
